<template>
  <v-container fluid class="pa-0 split-view-container">
    <!-- Left panel -->
    <div :style="{ width: leftWidth + 'px', minWidth: '150px' }" class="left-panel">
      <slot name="left" />
    </div>

    <!-- Draggable divider -->
    <div
      class="divider"
      @mousedown="startDrag"
    ></div>

    <!-- Right panel -->
    <div class="right-panel">
      <slot name="right" />
    </div>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const leftWidth = ref(300)
const isDragging = ref(false)
const dragOffset = ref(0)
let animationFrame = null

function startDrag (e) {
  dragOffset.value = e.clientX - leftWidth.value
  isDragging.value = true
  document.body.style.userSelect = 'none'
  document.documentElement.classList.add('resizing')
}

function stopDrag () {
  isDragging.value = false
  document.body.style.userSelect = ''
  document.documentElement.classList.remove('resizing')
  if (animationFrame) {
    cancelAnimationFrame(animationFrame)
    animationFrame = null
  }
}

function onDrag (e) {
  if (!isDragging.value) return
  if (animationFrame) return // already scheduled

  animationFrame = requestAnimationFrame(() => {
    leftWidth.value = Math.max(150, e.clientX - dragOffset.value)
    animationFrame = null
  })
}

onMounted(() => {
  window.addEventListener('mousemove', onDrag)
  window.addEventListener('mouseup', stopDrag)
})
onBeforeUnmount(() => {
  window.removeEventListener('mousemove', onDrag)
  window.removeEventListener('mouseup', stopDrag)
})
</script>

<style scoped>
.split-view-container {
  display: flex;
  overflow: hidden;
  height: 100%;
}

.left-panel {
  overflow: visible;
  flex-shrink: 0;
}

.right-panel {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 250px;
}

.divider {
  width: 3px;
  cursor: col-resize;
  background-color: rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
}
.divider:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
